/* eslint-disable react/prop-types */

import { Box, Typography } from "@mui/material";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import { alpha } from "@mui/material/styles";

export default function EmptyBusinessState() {
    return (
        <Box
            sx={{
                py: 7,
                textAlign: "center",
                borderRadius: 4,
                bgcolor: alpha("#f8fafc", 0.85),
                border: "1px dashed rgba(148,163,184,0.45)",
            }}
        >
            <StorefrontRoundedIcon
                sx={{
                    fontSize: 50,
                    color: "#94a3b8",
                    mb: 1,
                }}
            />

            <Typography fontWeight={950} sx={{ color: "#0f172a" }}>
                بیزینسی یافت نشد
            </Typography>

            <Typography variant="body2" sx={{ mt: 0.5, color: "#64748b", fontWeight: 600 }}>
                نام بیزینس را تغییر دهید یا دوباره جستجو کنید.
            </Typography>
        </Box>
    );
}